import * as eHubApi from "services/data.service";

function login(userName, userPassword) {
  //Return token, refreshToken, userId, Name
  return eHubApi.post("/api/account/login", { userId: userName, userPassword, loginSite: 'ehub' });
}

function logout(req) {
  return eHubApi.post("/api/account/logout", req);
}

function isTokenValid(jwToken) {
  return eHubApi.post("/api/account/isValid", { jwToken });
}

function getToken(refreshToken) {
  return eHubApi.post("/api/account/getNewToken", { refreshToken });
}

function sessionCheck() {
  return eHubApi.get("/api/account/session");
}

function getUserList() {
  return eHubApi.get("/api/account/list");
}

function refreshToken(refreshToken){
  return eHubApi.post("/api/account/refresh",{refreshToken})
}

//dummyTest
function getUserListPaginated(pageIndex, pageSize) {
  return eHubApi.get(`/api/dummy/getUsers?pageIndex=${pageIndex}&pageSize=${pageSize}`);
}

//changePassword
function changePassword(userName, userPassword, newPassword){
  return eHubApi.post("/api/account/change-password", { userId: userName, userPassword, newPassword: newPassword });
}

function permission({teams, admin}) {
  const teamString = teams?.length
  ? "&teams=" + teams.join("&teams=")
  : "";
  return eHubApi.get(`/api/account/permission?admin=${admin}${teamString}`);
}

export { login, logout, isTokenValid, getToken, sessionCheck, getUserList,refreshToken, getUserListPaginated, changePassword, permission };
